import {Box, Skeleton, Text} from '@mantine/core'
import {range} from 'lodash'
import {ProjectBadge} from '../calendar/components/badges/ProjectBadge.tsx'
import type {ProjectId} from '@package/shared'
import {useMemo} from 'react'
import {formatHours} from '../calendar/formatter/formatHours.ts'

type Props = {
  data: {projectId: ProjectId; hours: number}[]
  loading: boolean
}

export const HoursByProjectTable = ({data, loading}: Props) => {
  const totalHours = data.reduce((sum, data) => sum + data.hours, 0)

  const sortedData = useMemo(() => data.toSorted((a, b) => b.hours - a.hours), [data])

  return (
    <table>
      <thead>
        <tr>
          <th align={'left'} style={{minWidth: 130}}>
            <Text fw={'bold'}>Project</Text>
          </th>
          <th align={'left'} colSpan={2} style={{width: 100}}>
            <Text fw={'bold'}>Hours</Text>
          </th>
        </tr>
      </thead>
      <tbody>
        {loading &&
          range(0, 3).map((i) => (
            <tr key={i}>
              <td>
                <Skeleton w={120}>
                  <Box pr={'md'}>
                    <Text>-</Text>
                  </Box>
                </Skeleton>
              </td>
              <td colSpan={2}>
                <Skeleton w={70}>
                  <Text>-</Text>
                </Skeleton>
              </td>
            </tr>
          ))}
        {!loading && sortedData.length === 0 && (
          <tr>
            <td colSpan={2}>
              <Text c={'dimmed'}>No data</Text>
            </td>
          </tr>
        )}
        {sortedData.map((entry) => (
          <tr key={entry.projectId}>
            <td>
              <Box pr={'md'}>
                <ProjectBadge projectId={entry.projectId} />
              </Box>
            </td>
            <td align={'right'}>
              <Text>{formatHours(entry.hours)}</Text>
            </td>
            <td>
              <Text c={'dimmed'}>({((entry.hours / totalHours) * 100).toFixed(0)}%)</Text>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
